import { IsOptional, IsString } from 'class-validator';

export class CadastroAlterarObservacaoDto {
  @IsString()
  @IsOptional()
  observacao?: string;
}
